import { map, flatMap } from 'rxjs/operators';
import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { DataService, ApiService, InspectionPluginService } from '../../shared/services/index';
import { InspectionPlugin } from '../../shared/models/index';
import { TimeCounterPluginFactoryService } from './timecouner-plugin-factory.service';

@Injectable()
export class TimeCounterPluginService extends InspectionPluginService {
  constructor(
    protected apiService: ApiService,
    protected dataService: DataService,
    private timeCounterFactory: TimeCounterPluginFactoryService
  ) {
    super(apiService, dataService, null, timeCounterFactory);
  }

  public updateTimeCounter(
    inspectionId: string,
    pointId: string,
    pluginId: string,
    hours: number,
    minutes: number
  ): Observable<any> {
    const data = { Hours: hours, Minutes: minutes };
    return this.update(inspectionId, pointId, pluginId, data).pipe(
      map((res: InspectionPlugin) => {
        return this.dataService.updatePlugin(inspectionId, res);
      })
    );
  }

  private update(inspectionId: string, pointId: string, pluginId: string, data: any): Observable<any> {
    return this.timeCounterFactory.updateTimeCounter(inspectionId, pointId, pluginId, data).pipe(
      flatMap((plugin) => {
        if (this.isInspectionInOffline(inspectionId)) {
          return of(plugin);
        }
        return this.apiService.post(plugin.postServerUrl, plugin.config);
      })
    );
  }
}
